import { Pencil, Power, PowerOff, Trash2 } from 'lucide-react';

interface CatalogRowActionsProps {
  isActive: boolean;
  onEdit: () => void;
  onToggleActive: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

/**
 * Per-row Edit / Deactivate-or-Reactivate / Delete buttons shared by all catalog managers.
 *
 * - Deactivate is the safe, reversible option for delisted items.
 * - Delete is permanent and is refused by the server for items with complaint history.
 */
export function CatalogRowActions({
  isActive,
  onEdit,
  onToggleActive,
  onDelete,
  disabled,
}: CatalogRowActionsProps) {
  const base = 'p-2 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed';
  return (
    <div className="flex items-center gap-1">
      {isActive && (
        <button
          type="button"
          onClick={onEdit}
          disabled={disabled}
          className={`${base} text-gray-500 hover:text-gray-700 hover:bg-gray-100`}
          title="Edit"
          aria-label="Edit"
        >
          <Pencil className="w-4 h-4" />
        </button>
      )}
      <button
        type="button"
        onClick={onToggleActive}
        disabled={disabled}
        className={`${base} text-gray-500 hover:text-gray-700 hover:bg-gray-100`}
        title={isActive ? 'Deactivate (hide from complaint form; reversible)' : 'Reactivate'}
        aria-label={isActive ? 'Deactivate' : 'Reactivate'}
      >
        {isActive ? <PowerOff className="w-4 h-4" /> : <Power className="w-4 h-4" />}
      </button>
      <button
        type="button"
        onClick={onDelete}
        disabled={disabled}
        className={`${base} text-gray-500 hover:text-red-600 hover:bg-red-50`}
        title="Delete permanently (only possible when no complaint references this item)"
        aria-label="Delete"
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
}
